import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { Utility } from "src/app/core/common";

@Directive({
  selector: '[highlights]'
})
export class HighlightDirective {
  @Input() highlights: string[];

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {


    this.highlights = this.highlights.filter(w => w !== '');
    this.highlights = this.highlights.filter(w => w !== undefined);
    this.highlights = this.highlights.filter(w => w !== null);

    if (!this.highlights?.length) return;

    this.el.nativeElement.querySelectorAll('*') // get all children
      .forEach(elem => {
        //if elem has no child
        if (!elem.children.length) {
          elem.innerHTML = Utility.highlightSearch(elem.innerText, this.highlights.join(' '));
        }
      });
  }

  private removeHighlights() {
    const spans = this.el.nativeElement.querySelectorAll('span[my-highlighter]');

    var elms = spans, l = elms.length, i;
    for (i = l - 1; i >= 0; i--) {
      while (elms[i].firstChild)
        elms[i].parentNode.insertBefore(elms[i].firstChild, elms[i]);
      elms[i].parentNode.removeChild(elms[i]);
    }

  }
}